/**
 * Static UI translation locale loader.
 * One JSON file per language; fallback chain: current language → English → key.
 */
import en from "../locales/English.json";
import sv from "../locales/Swedish.json";
import ka from "../locales/Georgian.json";
import lv from "../locales/Latvian.json";
import ru from "../locales/Russian.json";
import uk from "../locales/Ukrainian.json";

const locales = {
  English: en,
  Swedish: sv,
  Georgian: ka,
  Latvian: lv,
  Russian: ru,
  Ukrainian: uk,
};

const FALLBACK_LANGUAGE = "English";

/**
 * @param {string} language - Language name (e.g. user.languages.ui)
 * @returns {Record<string, string>} Locale strings for that language
 */
export function getLocale(language) {
  const lang = (language && String(language).trim()) || FALLBACK_LANGUAGE;
  return locales[lang] || locales[FALLBACK_LANGUAGE] || {};
}

/**
 * Resolve translation with optional variable substitution.
 * @param {Record<string, string>} locale - Locale object from getLocale
 * @param {string} key - Dot-separated key (e.g. "report.date")
 * @param {Record<string, string | number>} [replacements] - e.g. { count: 5, taskName: "Task A" }
 * @returns {string}
 */
export function translate(locale, key, replacements = {}) {
  const fallbackLocale = getLocale(FALLBACK_LANGUAGE);
  let str =
    (locale && locale[key]) ||
    (fallbackLocale && fallbackLocale[key]) ||
    key;

  if (replacements && typeof str === "string") {
    Object.entries(replacements).forEach(([k, v]) => {
      str = str.replace(new RegExp(`\\{\\{${k}\\}\\}`, "g"), String(v));
    });
  }

  return str;
}
